/** @jsxImportSource @emotion/react */
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

// import timeSlot from '../../../../../assets/about/time-slot.svg';
import phone from '../../../../../assets/about/phone.svg';
import globe from '../../../../../assets/about/globe.svg';
import mail from '../../../../../assets/about/mail.svg';

import stationFooterStyle from './station-footer.styles';
import { useParams } from 'react-router-dom';
import { useGetLocationByIdQuery } from '../../../../../api/locations/locations.api';
import { toAbsoluteUrl } from '../../../../../utils/utils';

type TProps = {
    shouldShowAboutTitle?: boolean;
    styles?: any;
};

export const StationFooter: FC<TProps> = props => {
    const { shouldShowAboutTitle = true, styles = {} } = props;
    const { locationId } = useParams();
    const intl = useIntl();

    const { data: location } = useGetLocationByIdQuery(locationId ?? '');

    return (
        <>
            <div css={[stationFooterStyle.container, styles]}>
                {location && shouldShowAboutTitle && (
                    <div css={stationFooterStyle.title}>
                        {intl.formatMessage({ id: 'footer.title.aboutLocation' })}
                    </div>
                )}

                <div css={stationFooterStyle.content}>
                    {location?.data?.phoneNumber && (
                        <div css={stationFooterStyle.infoBlock}>
                            <div css={stationFooterStyle.infoBlockIcon}>
                                <img width={23} src={phone} alt={'Support'} />
                            </div>
                            <a
                                css={stationFooterStyle.infoBlockValue}
                                href={`tel:${location?.data?.phoneNumber}`}
                                target={'_blank'}
                                rel="noreferrer">
                                {location?.data?.phoneNumber}
                            </a>
                        </div>
                    )}

                    {/* {location?.data?.workingHours && (
                        <div css={stationFooterStyle.infoBlock}>
                            <div css={stationFooterStyle.infoBlockIcon}>
                                <img height={23} src={timeSlot} alt={'Working hours'} />
                            </div>
                            <div>
                                <div css={stationFooterStyle.infoBlockValue}>
                                    {location?.data?.workingHours}
                                </div>
                            </div>
                        </div>
                    )} */}

                    {location?.data?.email && (
                        <div css={stationFooterStyle.infoBlock}>
                            <div css={stationFooterStyle.infoBlockIcon}>
                                <img width={23} src={mail} alt={'E-mail'} />
                            </div>
                            <div>
                                <div>
                                    <a
                                        target="_blank"
                                        css={stationFooterStyle.infoBlockValue}
                                        href={`mailto:${location?.data?.email}`}
                                        rel="noreferrer">
                                        {location?.data?.email}
                                    </a>
                                </div>
                            </div>
                        </div>
                    )}

                    {location?.data?.website && (
                        <div css={stationFooterStyle.infoBlock}>
                            <div css={stationFooterStyle.infoBlockIcon}>
                                <img height={23} src={globe} alt={'Website'} />
                            </div>
                            <div>
                                <div css={stationFooterStyle.infoBlockValue}>
                                    <a
                                        css={stationFooterStyle.link}
                                        href={toAbsoluteUrl(location?.data?.website)}
                                        target={'_blank'}
                                        rel="noreferrer">
                                        {location?.data?.website}
                                    </a>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};
